import React from 'react';
import { MockedProvider } from '@apollo/client/testing';
import { ApolloProvider } from '@apollo/client';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';
interface ProviderProps {
  useMocks?: boolean;
  mocks?: Array<any>;
  srcClient?: string;
  defaultOptions?: any;
}

export const GraphQLProvider: React.FC<ProviderProps> = ({
  useMocks,
  srcClient = ProxyGraphClients.ANS,
  mocks = [],
  defaultOptions,
  children,
}) => {
  if (useMocks) {
    return (
      <MockedProvider mocks={mocks} addTypename={false} defaultOptions={defaultOptions}>
        {children}
      </MockedProvider>
    );
  }
  return (
    <ApolloProvider client={abgGraphqlClient(srcClient)}>
      <>{children}</>
    </ApolloProvider>
  );
};
